import {ObsArray} from "@kta20-core/utils/obs-array";
import {IKbRecord} from "@kta20-knowledge-base/interfaces/i-kb-record";
import {KB_RECORD_TYPE_CONFIG, KB_SEARCH_RECORD_DETAIL, KB_SEARCH_RECORDS} from "@kta20-knowledge-base/constants";
import {FetchError} from "@kta20-core/errors/fetch-error";
import {OfflineError} from "@kta20-core/errors/offline-error";
import {CustomError} from "@kta20-core/errors/custom-error";
import {IKbService} from "@kta20-knowledge-base/interfaces/i-kb-service";
import {HttpService} from "@kta20-core/net/http-service";


export class KbService extends HttpService implements IKbService {

    protected static inst: KbService;

    readonly records: ObsArray<IKbRecord> = new ObsArray<IKbRecord>([]);
    readonly recordDetail: ObsArray<IKbRecord> = new ObsArray<IKbRecord>([]);
    readonly recordTypesConfig: ObsArray<string> = new ObsArray<string>([]);

    /**
     * @param value
     * @throws {CustomError | FetchError}
     */
    async loadRecords(value: string): Promise<void> {
        await this.load<IKbRecord>(
            this.records,
            `/kb-records/search/${value}`,
            //uses default one or allows the client to store search results in different cache stores
            KB_SEARCH_RECORDS
        );
    }

    /**
     *
     * @param id
     * @param searchId
     * @param recordType
     * @throws {CustomError | FetchError}
     */
    async getRecord(id: string,searchId:string,recordType:string): Promise<void> {
        await this.load<IKbRecord>(
            this.recordDetail,
            `/kb-records/${id}?searchId=${searchId}&recordType=${recordType}`,
            `${KB_SEARCH_RECORD_DETAIL}.${id}`
        );
    }

    /**
     *
     * @param resourceUrl
     * @throws {FetchError | OfflineError}
     */
    async downloadFile(resourceUrl: string): Promise<Blob> {

        if (!this.networkService.hasNetwork()) throw new OfflineError();

        let blob: Blob = null;

        try {
            this.isRequestInProgress = true;

            blob = await this.wretch
                .auth('Bearer ' + await this.getTokenBy())
                .url(resourceUrl)
                .get()
                .blob();
        } catch (e) {
            console.warn(e);
            this.isRequestInProgress = false;
            throw new FetchError();
        }

        this.isRequestInProgress = false;
        return blob;
    }

    /**
     * @throws {CustomError | FetchError}
     */
    async getAvailableRecordTypeConfig(): Promise<void> {
        await this.load<string>(
            this.recordTypesConfig,
            `/kb-records-config`,
            KB_RECORD_TYPE_CONFIG
        );
    }

    /**
     *
     * @param ratingOption
     * @param kbRecord
     * @throws {CustomError | FetchError | OfflineError}
     */
    async rate(ratingOption: number, kbRecord: IKbRecord): Promise<IKbRecord> {

        if (!this.networkService.hasNetwork()) throw new OfflineError();

        let updatedRecord;

        try {
            this.isRequestInProgress = true;

            updatedRecord = await this.wretch
                .auth('Bearer ' + await this.getTokenBy())
                .url(`/kb-records/${kbRecord.id}/rate`)
                .put({
                    ratingOption: ratingOption,
                    recordId: kbRecord.id,
                    searchId: kbRecord.searchId,
                    recordType:kbRecord.type
                })
                .json();

            this.isRequestInProgress = false;
        } catch (e) {
            this.isRequestInProgress = false;
            throw new FetchError();
        }

        try {
            kbRecord.humanRatings = (<any>updatedRecord).humanRatings;
        } catch (e) {
            console.error(e);
            throw CustomError.ensureTyped(e);
        }

        return kbRecord;
    }
}